import { Injectable } from "@angular/core";
import Mustache from "mustache";

declare const ejs: any;

@Injectable()
export class TemplateService {
  render(template: string, data: Record<string, any>, options?: any): string {
    return ejs.render(template, data, options);
  }

  async renderMustache(
    template: string,
    view: Record<string, any>
  ): Promise<string> {
    return Mustache.render(template, view);
  }
}
